<script lang="ts">
  import { onMount } from "svelte";
  import { blogList } from "./../../../app/store/store-blog";
  import VerticalBlogCard from "./VerticalBlogCard.svelte";
  import HorizontalBlogCard from "./HorizontalBlogCard.svelte";
  import WaitlistFooter from "../../footer/waitlist/WaitlistFooter.svelte";
  import MainFooter from "../../footer/main-footer/MainFooter.svelte";
  import { waitBlogContentReady } from "../utils";

  const firstBlog = blogList[0];
  const remainBlog = blogList.slice(1);
  let contentReady: boolean = false;

  onMount(() => {
    waitBlogContentReady(() => {
      contentReady = true;
    });
  });
</script>

<div class:hidden={!contentReady}>
  <div class="blog-container">
    <div class="blog-heading">
      <div class="blog-list-title">Datadocs Blog</div>

      <div class="blog-list-description">
        Learn about Datadocs technology and helpful tips & tricks for getting
        the best out the product.
      </div>
    </div>

    <div class="blog-content">
      <div class="blog-list">
        <div class="first-blog">
          <VerticalBlogCard blog={firstBlog} />
        </div>

        {#if remainBlog.length > 0}
          <div class="remain-blog">
            {#each remainBlog as blog}
              <HorizontalBlogCard {blog} />
            {/each}
          </div>
        {/if}
      </div>
    </div>
  </div>

  <WaitlistFooter />
  <MainFooter />
</div>

<style lang="postcss">
  .hidden {
    display: none;
  }

  .blog-container {
    margin: 40px auto 96px auto;
  }

  .blog-heading {
    @apply text-center mx-auto mb-12;
    width: min(720px, calc(100% - 20px));
  }

  .blog-list-title {
    @apply text-center mt-12 typo-heading-1;
    background: linear-gradient(90.76deg, #5f89ff 0%, #3bc7ff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }

  @media (max-width: 640px) {
    .blog-list-title {
      @apply typo-heading-2;
      font-weight: 700;
    }
  }

  .blog-list-description {
    @apply text-center mx-auto mt-4 typo-paragraph-1 text-dark-50;
    width: min(520px, calc(100% - 32px)) !important;
  }

  .blog-content {
    @apply mx-auto;
    width: 1088px;
    letter-spacing: 0.02em;
  }

  .blog-list {
    @apply flex flex-row justify-center space-x-8;
  }

  .first-blog {
    width: 620px;
  }

  .remain-blog {
    @apply flex flex-col gap-3 items-start justify-start;
    width: 436px;
  }

  @media (max-width: 1108px) {
    .blog-content {
      width: min(620px, calc(100% - 20px));
    }

    .blog-list {
      @apply flex-col items-center space-x-0 space-y-8;
    }

    .first-blog,
    .remain-blog {
      width: 100%;
    }
  }
</style>
